import { useEffect, useRef, useState } from "react";
import styles from "./styles.module.scss";
import { DIRECTIONS, FC, Props } from "./typings";
import { useOnClickOutside } from "usehooks-ts";
import classNames from "classnames";

const DropdownLogic: FC<Props> = ({ toggle, className, right, children }) => {
  const [dropdownPosition, setDropdownPosition] = useState<DIRECTIONS>(
    DIRECTIONS.HIDDEN
  );

  const [posX, setPosX] = useState(-1);

  const dropdownRef = useRef<HTMLDivElement | null>(null);

  useOnClickOutside(dropdownRef, () => {
    if (toggle) {
      toggle();
    }
  });

  useEffect(() => {
    if (dropdownRef.current) {
      const dropdownRect = dropdownRef.current.getBoundingClientRect();
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;

      const actualX = dropdownRect.x + dropdownRect.width;

      if (actualX > viewportWidth) {
        setPosX(viewportWidth - dropdownRect.width - 8);
      }

      if (dropdownRect.bottom > viewportHeight) {
        setDropdownPosition("above");
      } else {
        setDropdownPosition("below");
      }
    }
  }, []);

  return (
    <div
      style={{
        opacity: dropdownPosition === DIRECTIONS.HIDDEN ? 0 : 1,
        right: right ?? (posX === -1 ? undefined : 0),
      }}
      ref={dropdownRef}
      className={classNames(
        styles.wrapper,
        styles[dropdownPosition],
        className
      )}
    >
      {children}
    </div>
  );
};

export default DropdownLogic;
